export default from './UnifiedCookiesPolicy';



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/UnifiedCookiesPolicy/index.js